import React from "react";

// COPY LOCKED — do not paraphrase without client confirmation. See /app/memory/PRD.md.

/* Restrained architectural line icons — 40x40 with 1px stroke */
const IconRear = () => (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" stroke="currentColor" strokeWidth="1" aria-hidden="true">
        <rect x="6" y="10" width="24" height="24" />
        <rect x="30" y="18" width="8" height="16" />
        <line x1="10" y1="34" x2="38" y2="34" strokeOpacity="0.4" />
    </svg>
);
const IconSide = () => (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" stroke="currentColor" strokeWidth="1" aria-hidden="true">
        <rect x="6" y="14" width="20" height="20" />
        <rect x="26" y="20" width="12" height="14" />
        <line x1="10" y1="34" x2="38" y2="34" strokeOpacity="0.4" />
    </svg>
);
const IconLoft = () => (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" stroke="currentColor" strokeWidth="1" aria-hidden="true">
        <polyline points="6,26 22,10 38,26" />
        <rect x="10" y="26" width="24" height="10" />
        <line x1="10" y1="36" x2="34" y2="36" strokeOpacity="0.4" />
    </svg>
);
const IconRecon = () => (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" stroke="currentColor" strokeWidth="1" aria-hidden="true">
        <rect x="6" y="8" width="32" height="28" />
        <line x1="6" y1="20" x2="22" y2="20" />
        <line x1="22" y1="20" x2="22" y2="36" />
        <line x1="22" y1="28" x2="38" y2="28" />
    </svg>
);

const ITEMS = [
    { icon: IconRear, title: "Rear Extensions", body: "Create more space and improve the connection between your home and garden." },
    { icon: IconSide, title: "Side Extensions", body: "Make better use of underused space to create a larger, more practical home." },
    { icon: IconLoft, title: "Loft Conversions & Extensions", body: "Unlock additional bedrooms, bathrooms, workspace or living accommodation." },
    { icon: IconRecon, title: "Internal Reconfigurations", body: "Explore better ways to organise and use the space you already have." },
];

export default function WhatWeDesign() {
    return (
        <section id="what-we-design" className="bg-offwhite py-12 md:py-16" data-testid="section-what-we-design">
            <div className="max-w-[1200px] mx-auto px-6 md:px-10">
                <p className="font-manrope font-semibold text-terracotta text-[12px] tracking-[0.22em] uppercase mb-4">
                    What We Design
                </p>
                <h2 className="font-manrope font-bold text-charcoal text-[34px] md:text-[44px] leading-[1.05] tracking-tight mb-14 md:mb-20 max-w-[720px]">
                    Project Types
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-10">
                    {ITEMS.map(({ icon: Icon, title, body }) => (
                        <div key={title} className="flex flex-col text-charcoal" data-testid={`design-card-${title.split(" ")[0].toLowerCase()}`}>
                            <div className="mb-6 text-charcoal">
                                <Icon />
                            </div>
                            <h3 className="font-manrope font-bold text-[19px] md:text-[20px] mb-3 leading-tight">
                                {title}
                            </h3>
                            <p className="font-inter text-[15px] leading-relaxed text-charcoal/70">
                                {body}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
